import Vue from 'vue'
import Vuex from 'vuex'
import api from "../common/js/api2.js"
Vue.use(Vuex);



var w=window.innerWidth
|| document.documentElement.clientWidth
|| document.body.clientWidth;
 // w > 678 ? false :true,


var userInfo = api.getGhStorageItem("userInfo");
if(!userInfo){
	userInfo = {};
	userInfo.nickname = "";
}

var contact = api.getGhStorageItem("contact");

if(!contact){
    contact = {};
    contact.logo="";
}



const store = new Vuex.Store({

	state: {
		userInfo:userInfo , //用户信息
		contact:contact ,
		token: api.getGhStorageItem("token"),
		bind:null,
		web: w > 678 ? false :true,
		order:api.getStorageItem("order"),

	},
	mutations: {
		SET_USER(state, data) {
			state.userInfo = data;
		},
		SET_CONTACT(state, data) {
			state.contact = data;
		},
		SET_TOKEN(state, data) {
			state.token = data;
		},
		
		SET_ORDER(state, data) {
			api.setStorageItem("order", data)
			state.order = data;
		},
		SET_BIND(state, data) {		
			state.bind = data;
		},

	},
	actions: {
		SET_BIND({
			commit
		}, data) {
			commit('SET_BIND', data);
		},
		SET_ORDER({
			commit
		}, data) {
			commit('SET_ORDER', data);
		},
		SET_TOKEN({
			commit
		}, data) {
			api.setGhStorageItem("token", data)
			commit('SET_TOKEN', data);
		},
		SET_CONTACT({
			commit
		}, data) {
			api.setGhStorageItem("contact", data)
			commit('SET_CONTACT', data);
		},
		SET_USER({
			commit
		}, data) {
			api.setGhStorageItem("userInfo", data)
			commit('SET_USER', data);
		},
	}


});
export default store


// import {mapState} from 'vuex'
// computed: {
// 			 ...mapState({
//                   userInfo: state => state.userInfo,
//                   contact: state => state.contact
//             }),
// 		},
// app.$store.dispatch('SET_USER',res.data.user);



// WEBPACK FOOTER //
// ./src/store/index.js